(function (angular, ToyotaForms) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyValidEmail', ['$filter', 'API', '$q', function Map($filter, API, $q) {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    var email;

                    ctrl.$asyncValidators.email = function (modelValue) {

                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return $q.when();
                        }
                        else if (!ToyotaForms.RegularExpressions.EmailPattern.test(modelValue)) {
                            return $q.reject();
                        }

                        var def = $q.defer();

                        email = $filter('formatArgs')(ToyotaForms.API.Validation.Email, [encodeURIComponent(modelValue)]);

                        API.get(email)
                            .then(function (req) {
                                if (req.data.isValid) {
                                    def.resolve();
                                }
                                else {
                                    def.reject();
                                }
                            }, function () {
                                def.reject();
                            });
                        return def.promise;
                    };
                }
            };

        }]);
})(window.angular, window.ToyotaForms);
